var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-message",class:{ 'own-message': _vm.own }},[_vm._v(" "+_vm._s(_vm.getDate)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }